/* eslint-disable max-len */
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
// import { UIChart } from 'primeng/chart';
import { LANGUAGES } from 'src/app/conf/languages';
import { AppState } from 'src/app/store/app.reducer';
import * as UserActions from 'src/app/store/user/user.actions';
import { Observable, Subscription } from 'rxjs';
import { User } from 'src/app/model/user';
import { selectUser } from 'src/app/store/user/user.selector';
import { StandardPageLayout } from '../shared/stdlayoutlib/classes.stdlayoutlib';

@Component({
	selector: 'app-public-fw-page-noauth',
	templateUrl: './public-fw-page-noauth.component.html',
})

export class PublicFwPageNoAuthComponent implements OnInit, OnDestroy {
	// @ViewChild('total') chart: UIChart;

	user$: Observable<User | undefined>;
	userSub: Subscription | undefined;

	guest = true;

	// design
	screenWidth: number;
	screenHeight: number;

	constructor(
		private route: ActivatedRoute,
		private translate: TranslateService,
		private store: Store<AppState>
	) {
		this.initSelectors();
	}

	initSelectors(): void {
		// Store selectors
		this.user$ = this.store.select(selectUser);
	}

	ngOnDestroy(): void {
		this.userSub?.unsubscribe();
	}

	ngOnInit() {
		// this.store.dispatch(NotificationsActions.setTopbarTitleId({
		// 	stringId: 'BUS_PAGE_TITLE'
		// }));
		this.userSub = this.user$?.subscribe(currentUser => {
			if (currentUser !== undefined && currentUser.Email !== undefined && currentUser.Email !== '') {
				this.guest = false;
			}
		});
		const lang = this.route.snapshot.queryParamMap.get('language');
		const langVal = LANGUAGES.find(l => l.code === lang);
		if (langVal !== undefined) {
			this.store.dispatch(UserActions.setCurrentLang({ lang: langVal }));
			if (langVal.code !== this.translate.currentLang && localStorage != null) {
				window.location.reload();
			}
		}


		// this.translate.onLangChange.subscribe(() => {
		// 	this.changeLegends();
		// });

		this.onResize();
	}

	downloadPlxIp3010() {
		const url = "https://download.cameconnect.net/firmware/intercom/CamePLXIP_3.0.10.swu"
		window.open(url);
	}

	getReleaseNotePlx3010(): string {
		const lang = this.translate.currentLang;
		switch (lang) {
			case 'it-IT': {
				return `
					<ul>
						<li><strong>Modifiche rispetto a ver 3.0.8</strong></br>
							<ul>
								<li>Corretto errore nel conteggio delle licenze app per PLXV in configurazione Master</li>
								<li>Migliorato controllo nella connessione a Came Connect per evitare attacchi di tipo “Machine-in-the-Middle”</li>
								<li>Ordine delle registrazioni di segreteria impostato dal più recente al meno recente</li>
								<li>Miglioramenti nella pagina di configurazione di rete e nella pagina credenziali per PLXV in configurazione Master</li>
								<li>Corretto errore nella registrazione di eventi di tipo “DELETE_VIDEOMESSAGE” nei log locali al dispositivo</li>
							</ul>
						</li>
					</ul>
					<ul>
						<li><strong>Modifiche rispetto a ver 3.0.4</strong></br>
							<ul>
								<li>Miglioramenti nella pagina di configurazione di rete</li>
								<li>Corretto errore di ripristino configurazione di fabbrica non funzionante se Came Connect non raggiungibile</li>
								<li>Risolto un problema di registrazione VoIP al master di impianto per PLXV in configurazione Slave</li>
								<li>Fix di sicurezza per CVE-2025-38352</li>
								<li>Fix di sicurezza per CVE-2023-44487</li>
								<li>Migliorie nella pagina di impostazioni SIP</li>
								<li>Migliorata visibilità della descrizione del chiamante in OSD nella schermata di chiamata videocitofonica</li>
								<li>Bug fix vari</li>
							</ul>
						</li>
					</ul>
					<ul>
						<li><strong>Modifiche rispetto a ver 2.0.5</strong></br>
							<ul>
								<li>Nuova interfaccia di configurazione web locale</li>
								<li>Nascosta la pagina delle segreterie videocitofoniche per l’utente “installer” (riservata solo all’utente “user”)</li>
								<li>Per il ripristino della configurazione vengono proposte 3 opzioni: ripristino configurazione di fabbrica, ripristino parametri di rete e ripristino configurazione di impianto</li>
								<li>Aggiunta la possibilità di chiamare, dal menù di rubrica, un portiere appartenente ad un gruppo di portieri</li>
								<li>Aggiunta gestione delle rotte statiche da pagina web di configurazione di rete</li>
								<li>Dal menù di selezione della suoneria, la melodia viene riprodotta anche se il dispositivo è in Mute</li>
								<li>Gestita la dissociazione dell’utente Came Connect dal keycode del PLXV al ripristino della configurazione di fabbrica</li>
								<li>Risolto un problema di registrazione VoIP al master di impianto per PLXV in configurazione Master</li>
								<li>Aggiunta in OSD dell'indicazione del chiamante nella schermata di chiamata videocitofonica</li>
								<li>Bug fix vari</li>
							</ul>
						</li>
					</ul>
				`;
			}
			default: { // 'en-US'
				return `
					<ul>
						<li><strong>Changes from ver 3.0.8</strong></br>
							<ul>
								<li>Fixed app license counting error for PLXV in Master configuration</li>
								<li>Improved connection control to Came Connect to prevent “Machine-in-the-Middle” attacks</li>
								<li>Answering machine recordings order set from most recent to oldest</li>
								<li>Improvements to the network configuration and credentials pages for PLXV in Master configuration</li>
								<li>Fixed error in logging “DELETE_VIDEOMESSAGE” events in the device local logs</li>
							</ul>
						</li>
					</ul>
					<ul>
						<li><strong>Changes from ver 3.0.4</strong></br>
							<ul>
								<li>Improvements to the network configuration page</li>
								<li>Fixed factory reset error occurring when Came Connect is unreachable</li>
								<li>Resolved a VoIP registration issue to the system master for PLXV in Slave configuration</li>
								<li>Security fix for CVE-2025-38352</li>
								<li>Security fix for CVE-2023-44487</li>
								<li>Improvements to the SIP settings page</li>
								<li>Improved visibility of the caller description in OSD during video entry calls</li>
								<li>Various bug fixes</li>
							</ul>
						</li>
					</ul>
					<ul>
						<li><strong>Changes from ver 2.0.5</strong></br>
							<ul>
								<li>New local web configuration interface</li>
								<li>Hidden the video entry answering machine page for the “installer” user (reserved for “user” only)</li>
								<li>Three options are provided for configuration reset: factory reset, network parameters reset, and system configuration reset</li>
								<li>Added the ability to call a concierge belonging to a concierge group from the phonebook menu</li>
								<li>Added static route management from the network configuration web page</li>
								<li>In the ringtone selection menu, the melody is played even if the device is muted</li>
								<li>Managed Came Connect user dissociation from the PLXV keycode during factory reset</li>
								<li>Resolved a VoIP registration issue to the system master for PLXV in Master configuration</li>
								<li>Added caller identification in OSD during video entry calls</li>
								<li>Various bug fixes</li>
							</ul>
						</li>
					</ul>
				`;
			}
		}
	}

	downloadXTS7IPWiFi703() {
		const url = "https://download.cameconnect.net/firmware/intercom/BptCameXTS-7IP_7_0_3.tgz"
		window.open(url);
	}

	// XTS 7 IP WiFi 7.0.3-V2 and XTS 7 IP WiFi 7.0.3
	getReleaseNoteXTS7IPWiFi703(): string {
		const lang = this.translate.currentLang;
		switch (lang) {
			case 'it-IT': {
				return `
					<ul>
						<li><strong>Modifiche rispetto alla versione 7.0.2</strong></br>
							<ul>
								<li>Corretto errore nel conteggio delle licenze app per XTS in configurazione Master</li>
								<li>Corretto errore nel cambio password nelle impostazioni SIP per XTS in configurazione Slave</li>
								<li>Migliorato controllo nella connessione a Came Connect per evitare attacchi di tipo “Machine-in-the-Middle”</li>
							</ul>
						</li>
					</ul>
					<ul>
						<li><strong>Modifiche rispetto alla versione 6.0.0</strong></br>
							<ul>
								<li>Nuova interfaccia di configurazione web locale</li>
								<li>Nascosta la pagina delle segreterie videocitofoniche per l’utente “installer” (riservata solo all’utente “user”)</li>
								<li>Per il ripristino della configurazione vengono proposte 3 opzioni: ripristino configurazione di fabbrica, ripristino parametri di rete e ripristino configurazione di impianto</li>
								<li>Nuova funzione videocitofonica “Apri e silenzia suoneria”</li>
								<li>Gestita la dissociazione dell’utente Came Connect dal keycode del XTS al ripristino della configurazione di fabbrica da configuratore web</li>
								<li>Risolto un problema di registrazione VoIP al master di impianto per XTS in configurazione Slave</li>
								<li>Fix di sicurezza per CVE-2023-44487</li>
								<li>Correzioni errori in alcuni testi di alcune lingue</li>
								<li>Miglioramento nella registrazione video di segreteria</li>
								<li>Migliorie nella pagina di impostazioni SIP</li>
								<li>Bug fix vari</li>
							</ul>
						</li>
					</ul>
					<ul>
						<li><strong>Modifiche rispetto alla versione 5.0.3</strong></br>
							<ul>
								<li>Salvataggio permanente dei volumi audio quando modificati dalla pagina della chiamata videocitofonica in corso</li>
								<li>Gestita la dissociazione dell’utente Came Connect dal keycode del XTS al ripristino della configurazione di fabbrica da UI</li>
								<li>Risolto un problema di registrazione VoIP al master di impianto per XTS in configurazione Master</li>
								<li>Fix di sicurezza per CVE-2025-38352</li>
								<li>Fix di sicurezza per vulnerabilità “path traversal via crafted tar file containing symlink”</li>
								<li>Bug fix vari</li>
							</ul>
						</li>
					</ul>
				`;
			}
			default: { // 'en-US'
				return `
					<ul>
						<li><strong>Changes from version 7.0.2</strong></br>
							<ul>
								<li>Fixed app license counting error for XTS in Master configuration</li>
								<li>Fixed password change error in SIP settings for XTS in Slave configuration</li>
								<li>Improved connection control to Came Connect to prevent “Machine-in-the-Middle” attacks</li>
							</ul>
						</li>
					</ul>
					<ul>
						<li><strong>Changes from version 6.0.0</strong></br>
							<ul>
								<li>New local web configuration interface</li>
								<li>Hidden the video entry answering machine page for the “installer” user (reserved for “user” only)</li>
								<li>Three options are provided for configuration reset: factory reset, network parameters reset, and system configuration reset</li>
								<li>New video entry function “Open and mute ringtone”</li>
								<li>Managed Came Connect user dissociation from the XTS keycode during factory reset via web configurator</li>
								<li>Resolved VoIP registration issue to the system master for XTS in Slave configuration</li>
								<li>Security fix for CVE-2023-44487</li>
								<li>Fixed text errors in various languages</li>
								<li>Improved answering machine video recording</li>
								<li>Improvements to the SIP settings page</li>
								<li>Various bug fixes</li>
							</ul>
						</li>
					</ul>
					<ul>
						<li><strong>Changes from version 5.0.3</strong></br>
							<ul>
								<li>Permanent saving of audio volumes when modified during an active video entry call</li>
								<li>Managed Came Connect user dissociation from the XTS keycode during factory reset via UI</li>
								<li>Resolved VoIP registration issue to the system master for XTS in Master configuration</li>
								<li>Security fix for CVE-2025-38352</li>
								<li>Security fix for “path traversal via crafted tar file containing symlink” vulnerability</li>
								<li>Various bug fixes</li>
							</ul>
						</li>
					</ul>
				`;
			}
		}
	}

	downloadXTS7IPWiFi703V2() {
		const url = "https://download.cameconnect.net/firmware/intercom/BptCameXTS-7IP-V2_7_0_3.tgz"
		window.open(url);
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
		this.screenHeight = window.innerHeight;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	overTablet() {
		return StandardPageLayout.overTablet(this.screenWidth);
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	layoutMarginResponsive(): string {
		return StandardPageLayout.layoutMarginResponsive(this.screenWidth);
	}

	customPaddingX(): string {
		return StandardPageLayout.customPaddingX(this.screenWidth);
	}
}
